import { Heading, Paragraph } from 'components/Typography';

type Props = {
  title: string;
  subtitle?: string;
};

const PreBookHeader: React.FC<Props> = ({ title, subtitle }) => (
  <>
    <Heading level="h2" data-testid="pre-book-header-title">
      {title}
    </Heading>
    {subtitle && (
      <Paragraph className="mt-12" data-testid="pre-book-header-subtitle">
        {subtitle}
      </Paragraph>
    )}
  </>
);

export default PreBookHeader;
